import { render } from "./LectureAndNotes.vue?vue&type=template&id=4a158369&scoped=true"
import script from "./LectureAndNotes.vue?vue&type=script&lang=js"
export * from "./LectureAndNotes.vue?vue&type=script&lang=js"

import "./LectureAndNotes.vue?vue&type=style&index=0&id=4a158369&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a158369"]])

export default __exports__